__turbopack_context__.v({
  "inline": "_9KKNmG_inline",
  "outletAvailabilityTag": "_9KKNmG_outletAvailabilityTag",
  "outletStatusText": "_9KKNmG_outletStatusText",
  "outletStatusWrapper": "_9KKNmG_outletStatusWrapper",
  "separator": "_9KKNmG_separator",
});
